import modelExtend from 'dva-model-extend';

import storage from 'utils/storage';
import { StorageKey } from 'constant';

import { model } from './common';

export default modelExtend(model, {
  namespace: 'tour',

  state: storage.getJson(StorageKey.TOUR_PARAMS) || {},

  effects: {
  },

  reducers: {
    updateParams(state, { payload }) {
      const newState = { ...state, ...payload };
      storage.setJson(StorageKey.TOUR_PARAMS, newState);
      return newState;
    },

    reset(state) {
      storage.setJson(StorageKey.TOUR_PARAMS, {});
      return {};
    },
  },
});



// WEBPACK FOOTER //
// ./src/models/tour.js